// Footer Component
import React from "react";
import { FOOTER_ALL_RIGHTS_RESERVED, FOOTER_WHELEN } from "../CommonConstants";

export default () => {
  // Get Year Data
  const getYear = () => new Date().getFullYear();
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="text-center">
            Copyright &copy;
            {getYear()}
            <a href="https://www.whelen.com/" rel="noreferrer" target="_blank" className="d-inline-block mx-2">
              {FOOTER_WHELEN}
            </a>
            {FOOTER_ALL_RIGHTS_RESERVED}
          </div>
        </div>
      </footer>
    </>
  );
};
